import { createPortal } from 'react-dom';
import Drawer from 'react-bottom-drawer';
import { ReactComponent as BlockedAlarmIcon } from '../../assets/imgs/chats/blocked-alarm-banner-icon.svg';
import { palette } from '../../theme/colors';
import { translate } from '../../utils/translate';
import { useActiveBlockingAlarm } from '../../utils/customHooks/useActiveBlockingAlarm';
import { Callout } from '../Callout';
import {
  Body,
  DrawerWrapper,
  IconCircle,
  OkButton,
  Title,
  TitleRow,
} from './SilentModeBottomSheet.styles';

type SilentModeBottomSheetProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SilentModeBottomSheet = ({ isOpen, setIsOpen }: SilentModeBottomSheetProps) => {
  const blockingAlarm = useActiveBlockingAlarm();
  const alarmName = blockingAlarm?.emergencyTypeName;

  const close = () => setIsOpen(false);

  return createPortal(
    <DrawerWrapper role="silentModeBottomSheet">
      <Drawer className="profileDrawer" isVisible={isOpen} onClose={close} hideScrollbars>
        <TitleRow>
          <IconCircle>
            <BlockedAlarmIcon fill={palette.gold} />
          </IconCircle>
          <Title>{translate('silent_mode_bottom_sheet_title')}</Title>
        </TitleRow>

        <Body>
          {alarmName
            ? translate('silent_mode_bottom_sheet_body', { alarmName })
            : translate('silent_mode_bottom_sheet_body_no_name')}
        </Body>

        <Callout
          labelTx="silent_mode_bottom_sheet_why_label"
          bodyTx="silent_mode_bottom_sheet_why_body"
        />

        <OkButton tx="silent_mode_bottom_sheet_close" onClick={close} />
      </Drawer>
    </DrawerWrapper>,
    document.body
  );
};
